import { SET_ORDER, SET_TOTAL } from '../types';

const initialState = {
  order: [],
  count: 0,
  total: 0,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ORDER:
      return {
        order: [...state.order, action.order],
        count: state.count + 1,
      };
    case SET_TOTAL:
      return {
        ...state,
        total: action.total,
      };

    default:
      return state;
  }
}
